var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListadoControlDeAccesos',{attrs:{"fields":_vm.fields,"controlAcessos":_vm.controlAcessosEntradasOtros,"filtros":_vm.filtros,"loading":_vm.loading},on:{"getcontrolAcessos":_vm.getControlAcessosEntradasOtros}})
}
var staticRenderFns = []

export { render, staticRenderFns }